export function formateDate(date: string): string {
  return new Date(date).toLocaleDateString("en-EG", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
}
